export default {
  All: 'all',
  NotFullyIssued: 'notFullyIssued',
  FullyIssued: 'fullyIssued',
}
